import React, { useEffect, useRef } from 'react';
import VanillaTilt from "vanilla-tilt";

function Tilt(props) {
    const { options, ...rest } = props;
    const tilt = useRef(null);
  
    useEffect(() => {
      VanillaTilt.init(tilt.current, options);
    }, [options]);
  
    return <div ref={tilt} {...rest} />;
  }

export default function ProjectComponent (title, desc, img) {
    const options = {
        scale: 1.1,
        // glare: true,
        // maxGlare: 0.1,
        reverse: true,
    }
    return (
        <Tilt className="personal-project-item-card"  options={options}>
        <div className="item-card-image" style={{backgroundImage: `linear-gradient(#fff0 0%, #fff0 70%, #151617 100%), url(${img})`}}>
          </div>
          <div className="item-card-desc">
            <h2> {title} </h2>
            <p className="personal-project-item-desc">
                {desc}
            </p>
          </div>
        </Tilt>

    )
}
